import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useUserCustomers, useRemoveUserCustomer } from "../hooks";
import { useMe } from "../../users/hooks/useMe";
import { UserRole } from "../../../__generated__/globalTypes";

interface IProps {
  userId: number;
}

export const UserCustomersList: React.FC<IProps> = ({ userId }) => {
  const { data, loading, refetch } = useUserCustomers({ where: { userId } });
  const [removeUserCustomer] = useRemoveUserCustomer();
  const { data: meData } = useMe();
  const isAdmin = meData?.me?.role === UserRole.Admin;

  if (loading) return <Loading />;

  if (!data?.userCustomers?.results?.length) {
    return <EmptyList text="Aucun client rattaché" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Client</TableCell>
          {isAdmin && (
            <TableCell header align="right">
              Actions
            </TableCell>
          )}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.userCustomers?.results?.map((userCustomer) => (
          <TableRow key={`user-customer-${userCustomer.id}`} hover={false}>
            <TableCell>{userCustomer.customerId}</TableCell>
            {isAdmin && (
              <TableCell align="right">
                <span
                  className="text-red-500 cursor-pointer"
                  onClick={async () => {
                    await removeUserCustomer({ variables: { id: userCustomer.id } });
                    refetch();
                  }}
                >
                  Retirer
                </span>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
